import UpdateCategory from "../features/finance/ui/UpdateCategory"

const UpdateCategoryPage = () => {
    return (
        <>
        <UpdateCategory />
        </>
    )
}
export default UpdateCategoryPage